export const ANALYTICS_TAB_DASHBOARD = 'ANALYTICS_TAB_DASHBOARD'
export const ANALYTICS_TAB_TABLE = 'ANALYTICS_TAB_TABLE'
export const ANALYTICS_TAB_DOWNLOAD = 'ANALYTICS_TAB_DOWNLOAD'
